var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLawbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 53,
    viewBox: "0 0 43 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 1.5H6.5C5.17392 1.5 3.90215 2.02678 2.96447 2.96447C2.02678 3.90215 1.5 5.17392 1.5 6.5V46.5C1.5 47.8261 2.02678 49.0979 2.96447 50.0355C3.90215 50.9732 5.17392 51.5 6.5 51.5H36.5C37.8261 51.5 39.0979 50.9732 40.0355 50.0355C40.9732 49.0979 41.5 47.8261 41.5 46.5V16.5M26.5 1.5L41.5 16.5M26.5 1.5V16.5H41.5M31.5 29H11.5M31.5 39H11.5M16.5 19H11.5",
    stroke: "#181D27",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawbook);
export default __webpack_public_path__ + "static/media/lawbook.255a7a8f8293572474a0ee0cde0303ba.svg";
export { ForwardRef as ReactComponent };